import SchemaOrg from '../../components/feature/SchemaOrg';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AsbestosOverview from './components/AsbestosOverview';
import InspectionSection from './components/InspectionSection';
import RemovalSection from './components/RemovalSection';
import SupervisionSection from './components/SupervisionSection';
import SafetySection from './components/SafetySection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <div className="min-w-[1024px]">
      <SchemaOrg />
      <Navbar />
      <HeroSection />
      <AsbestosOverview />
      <InspectionSection />
      <RemovalSection />
      <SupervisionSection />
      <SafetySection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
